/* eslint-disable react/jsx-props-no-spreading */
import Panel, { PanelProps } from 'component/UI/Panel'
import { FC } from 'react'
import { Form, FormInstance, Input, Select } from 'antd'
import { BroadcastFormValues } from 'component/Broadcast/BroadcastDetails'
import { QuickReplyAction, QuickReplyIntent } from 'types'
import MessagePreview from 'component/UI/MessagePreview'
import classNames from 'classnames'

import styles from './styles.module.scss'

interface BroadcastCampaignPanelProps extends PanelProps {
	form: FormInstance<BroadcastFormValues>
}

const { Item } = Form

const BroadcastCampaignPanel: FC<BroadcastCampaignPanelProps> = props => {
	const { form, ...panelProps } = props

	const defaultReplyAction = form
		.getFieldValue('qrBtnActionSetting')
		.find((intent: QuickReplyIntent) => intent.index === -1)?.action as
		| QuickReplyAction
		| undefined

	return (
		<Panel
			{...panelProps}
			className={classNames(panelProps.className ?? '', styles.panel)}
		>
			<Form layout='vertical'>
				<Item label='Intent' required>
					<Input value={defaultReplyAction?.intent ?? ''} disabled />
				</Item>

				<Item label='Response Message'>
					{defaultReplyAction?.responseMessage ? (
						<div className={styles.panel__responseMessages}>
							{defaultReplyAction.responseMessage.map((message, index) => (
								<MessagePreview
									showArrow={index === 0}
									key={index.toString()}
									message={message}
								/>
							))}
						</div>
					) : (
						<Input value='No response message' disabled />
					)}
				</Item>

				<Item label='Assign Tags'>
					<Select
						mode='multiple'
						options={(defaultReplyAction?.tags ?? []).map(tag => ({
							label: tag,
							value: tag,
						}))}
						value={defaultReplyAction?.tags ?? []}
						disabled
					/>
				</Item>

				<Item label='Assign Chat Labels'>
					<Select
						mode='multiple'
						options={(defaultReplyAction?.chatLabels ?? []).map(chatLabel => ({
							label: chatLabel,
							value: chatLabel,
						}))}
						value={defaultReplyAction?.chatLabels ?? []}
						disabled
					/>
				</Item>
			</Form>
		</Panel>
	)
}

export default BroadcastCampaignPanel
